module.exports = __webpack_public_path__ + "static/media/questions_success.60d59a38.svg";